import React from "react";
import CTAButton from "./CTAButton";

const modules = [
  { n: "01", title: "Fundamentos do TikTok Shop", desc: "Como funciona a plataforma, algoritmo e primeiros ajustes." },
  { n: "02", title: "Perfil dark com IA", desc: "Criando perfis lucrativos sem aparecer, com ferramentas de IA." },
  { n: "03", title: "Estrutura de vídeos que vendem", desc: "Ganchos, storytelling e chamadas para ação na prática." },
  { n: "04", title: "Curadoria de produtos", desc: "Como escolher produtos com potencial de escalar rápido." },
  { n: "05", title: "Edição de vídeos", desc: "Estilos de edição que engajam e mantem o espectador até o final." },
  { n: "06", title: "Live Shop", desc: "Preparando, montando e escalando lives que convertem." },
  { n: "07", title: "Análise de métricas", desc: "O que olhar, o que ignorar e como iterar rápido." },
  { n: "08", title: "Escala até 10K/mês", desc: "Rotina, produção em série e delegação simples." },
  { n: "09", title: "Comunidade e networking", desc: "Como aproveitar a VSA para acelerar." },
  { n: "10", title: "Ferramentas essenciais", desc: "Stack completa que você vai usar todo dia." },
  { n: "11", title: "IA ultra-realista", desc: "Criando avatares e narrações de alto nível." },
  { n: "12", title: "Bastidores dos alunos", desc: "Estudos de caso reais aplicando o método." },
];

const ModulesSection = () => {
  return (
    <section className="section" style={{ background: "#000" }}>
      <div className="container">
        <div style={{ textAlign: "center", marginBottom: 60 }}>
          <div className="eyebrow">MÓDULOS VSA</div>
          <h2 className="h-title" style={{ marginTop: 14, maxWidth: 900, marginInline: "auto" }}>
            Além disso, você vai ter acesso à <span className="yellow">Jornada do Zero ao Avançado</span>.
          </h2>
          <p style={{ maxWidth: 780, margin: "22px auto 0", color: "rgba(255,255,255,0.75)", fontSize: 17, lineHeight: 1.7 }}>
            Todos os módulos necessários e aulas simples e fáceis para você entender o jogo do dinheiro feito com IA para aplicar e escalar no TikTokShop.
          </p>
        </div>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: 20,
        }}>
          {modules.map((m, i) => (
            <div key={i} className="mod-card" style={{ padding: 24 }}>
              <div style={{
                fontSize: 38, fontWeight: 900,
                background: "linear-gradient(180deg, #FFE47A, #B88700)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                lineHeight: 1,
              }}>{m.n}</div>
              <h3 style={{ marginTop: 14, fontSize: 17, fontWeight: 800, lineHeight: 1.3 }}>{m.title}</h3>
              <p style={{ marginTop: 10, color: "rgba(255,255,255,0.65)", fontSize: 13.5, lineHeight: 1.6 }}>{m.desc}</p>
            </div>
          ))}
        </div>

        <div style={{ marginTop: 50, display: "flex", justifyContent: "center" }}>
          <CTAButton label="QUERO APLICAR O MÉTODO VSA" />
        </div>
      </div>
    </section>
  );
};

export default ModulesSection;
